import { APIExplorer, EditorConfigContext } from "@prismicio/editor-fields"
import { Box } from "@prismicio/editor-ui"

import { staticEditorConfig } from "../app/editorConfig"
import { useHeaderOffset } from "../app/layout/useOffset"
import {
  getRepositoryName,
  routeAnimationDuration,
  useRepositoryMetaTitle,
} from "../app/routing"
import { trackEditorEvent } from "../app/services/tracking"
import { mainContentMaxWidth } from "../document/documentLayout"
import { APIExplorerPageHeader } from "./APIExplorerPageHeader"

// Since this is a page outside of the document editor
// we need to exclude specific document fields from the config
// to get a correctly typed `EditorConfig` object.
const { searchDocuments, uidField, ...simpleConfig } = staticEditorConfig

export function APIExplorerPage() {
  const { headerOffset } = useHeaderOffset()

  useRepositoryMetaTitle("API Explorer")

  const repository = {
    id: getRepositoryName(),
    documentAPIEndpoint:
      // Use dedicated document API endpoint on non-prod environments
      !window.location.host.endsWith(".prismic.io")
        ? new URL("/api/v2", simpleConfig.coreApiBaseUrl.origin).toString()
        : undefined,
  }

  return (
    <Box
      position="fixed"
      top={headerOffset}
      flexDirection="column"
      animation={{ name: "fadeIn", duration: routeAnimationDuration }}
      maxHeight={`calc(100vh - ${headerOffset}px)`}
      width="100%"
      backgroundColor="grey2"
    >
      <APIExplorerPageHeader />
      <Box
        justifyContent="center"
        overflow="hidden"
        padding={{ top: 16, right: 16, left: 16 }}
        height="100vh"
      >
        <Box maxWidth={mainContentMaxWidth} width="100%">
          <EditorConfigContext.Provider value={simpleConfig}>
            <APIExplorer repository={repository} track={trackEditorEvent} />
          </EditorConfigContext.Provider>
        </Box>
      </Box>
    </Box>
  )
}
